import { resolveIcon } from '../../lib/icons';

interface AvatarSymbolPickerProps {
  symbols: string[];
  colors: string[];
  onPick: (symbol: string, colorHex: string) => void;
}

export function AvatarSymbolPicker({ symbols, colors, onPick }: AvatarSymbolPickerProps) {
  return (
    <div className="grid grid-cols-4 sm:grid-cols-6 gap-3">
      {symbols?.map((symbol, index) => {
        const colorHex = colors[index % colors.length];
        const Icon = resolveIcon(symbol);
        return (
          <button
            key={symbol}
            onClick={() => onPick(symbol, colorHex)}
            className="flex flex-col items-center gap-2 p-2 rounded-xl hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
          >
            <div
              className="w-14 h-14 rounded-2xl flex items-center justify-center"
              style={{ background: `${colorHex}2e` }}
            >
              <Icon size={24} color={colorHex} strokeWidth={2.2} />
            </div>
            <span className="text-[11px] text-black/50 dark:text-white/50 truncate max-w-full">{symbol}</span>
          </button>
        );
      })}
    </div>
  );
}
